import { Icon, useStyleConfig } from '@chakra-ui/react';
import React from 'react';

import { WLIconProps } from '../icon.props.interface';

const GraduateIcon: React.FC<WLIconProps> = ({ variant, ...rest }) => {
  const styles = useStyleConfig('Icon', { variant });

  return (
    <Icon viewBox="0 0 255 255" {...rest} __css={styles}>
      <desc id="svgdescInternships">graduate</desc>
      <path
        className="background"
        d="M127.5 0C57.2 0 0 57.2 0 127.5S57.2 255 127.5 255 255 197.8 255 127.5 197.8 0 127.5 0z"
      />
      <path
        className="accent"
        d="M199.9 192.5c-2.6-17-12.1-30-28.2-38.8-3.9-2.1-8-4.1-11.9-6-2.1-1-4.1-2-6.2-3-1.3-.7-2.7-1.3-3.4-1.8.3-.7 1-1.8 1.6-2.9l.2-.3c8.6-15 11.7-31.9 9.3-51.6-.4-3.8-1.4-7.2-2.9-10.2l-23 10.3c-2.3 1-5 1.5-7.8 1.5-3 0-5.9-.6-8.3-1.7L96.9 77c-1.7 3.3-2.9 7.1-3.5 11.3-.7 4.7-.8 10-.5 16.6.5 8.3 1.2 17.2 4.5 25.2 1.9 4.5 4.7 7.7 7.5 10.8 1 1.1 2 2.3 3 3.5.1.1.1.2.2.3-.2.1-.3.2-.6.3-3.1 1.5-6.9 2.6-10.8 3.8-4.7 1.4-9.6 2.8-13.6 5-16.2 8.9-25.7 22.1-28.2 39.3-1 7.1 1.7 11.3 8.8 13.1 4.3 1.1 8.6 1.9 13.3 2.7 11.9 2.1 23.7 3.1 32.7 3.8h35.2l6.6-.6c4.9-.5 10-.9 15-1.6 6.5-.8 15.1-2 23.6-4.1 8-2 10.9-6.3 9.8-13.9z"
      />
      <path
        className="accent"
        d="M80.4 56.9 122.2 77c2.9 1.4 7.7 1.5 10.6.1l42.2-19c2.9-1.3 3-3.5 0-4.9L134.5 34c-2.9-1.4-7.7-1.5-10.7-.3L78 51.8v3.9l2.4 1v.2z"
      />
      <path
        className="accent"
        d="m81.2 93.6-.8-36.7-2.4-1.2v37.6l-2.5 5.2h7.6z"
      />
    </Icon>
  );
};

export default GraduateIcon;
